import React from 'react';
import { StarIcon } from 'lucide-react';
const Hero = () => {
  const scrollToOffer = () => {
    const offerSection = document.getElementById('oferta');
    if (offerSection) {
      offerSection.scrollIntoView({
        behavior: 'smooth'
      });
    }
  };
  return <section className="w-full bg-[#F5EBE0] py-8 md:py-12" data-id="element-124">
      <div className="container mx-auto px-4" data-id="element-125">
        <div className="max-w-3xl mx-auto text-center" data-id="element-126">
          <h1 className="text-4xl md:text-5xl font-bold text-[#8B4513] mb-4" data-id="element-127">
            🥂 Tus invitados no recordarán lo que dijiste… pero jamás olvidarán
            lo que probaban.
          </h1>
          <div className="my-8" data-id="element-128">
            <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/w76BTmZtxqjQeqsa9j3gP9/Mockup_9_eBooks.png" alt="Combo Gourmet - Colección de eBooks" className="w-full max-w-2xl h-auto mx-auto rounded-lg shadow-xl" data-id="element-129" />
          </div>
          <h2 className="text-xl md:text-2xl font-medium text-[#A67C52] mb-6" data-id="element-130">
            ✨ Crea Bocaditos Gourmet Irresistibles como un Chef Profesional en
            menos de 24 horas con el Combo Gourmet de más de 10 eBooks
          </h2>
          <p className="text-lg mb-8 text-[#5E4B3C]" data-id="element-131">
            (+250 Recetas Exclusivas que activan el efecto WOW al primer bocado)
          </p>
          <div className="flex items-center justify-center mb-6" data-id="element-132">
            {[...Array(5)].map((_, i) => <StarIcon key={i} className="w-5 h-5 fill-[#FFD700] text-[#FFD700]" data-id="element-133" />)}
            <span className="ml-2 text-sm font-medium" data-id="element-134">
              +1,893 reseñas | 97% tasa de éxito
            </span>
          </div>
          <button onClick={scrollToOffer} className="bg-[#E25822] hover:bg-[#C64718] text-white font-bold py-4 px-8 rounded-lg text-lg shadow-lg transition-all transform hover:scale-105" data-id="element-135">
            Descargar Recetas Ahora
          </button>
        </div>
      </div>
    </section>;
};
export default Hero;